(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var asList = kotlin_kotlin.$_$.i5;
  var objectCreate = kotlin_kotlin.$_$.da;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.j4;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var emptyList = kotlin_kotlin.$_$.b6;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var classMeta = kotlin_kotlin.$_$.z8;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var KProperty1 = kotlin_kotlin.$_$.wa;
  var getPropertyCallableRef = kotlin_kotlin.$_$.h9;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var Entry = kotlin_kotlin.$_$.b5;
  var isInterface = kotlin_kotlin.$_$.t9;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var zip = kotlin_kotlin.$_$.w7;
  var toMap = kotlin_kotlin.$_$.q7;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var toString = kotlin_kotlin.$_$.ka;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var mapCapacity = kotlin_kotlin.$_$.w6;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.t;
  var Map = kotlin_kotlin.$_$.c5;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.k1;
  var captureStack = kotlin_kotlin.$_$.t8;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.l1;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.n1;
  var IllegalArgumentException = kotlin_kotlin.$_$.cd;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var KClass = kotlin_kotlin.$_$.va;
  var Triple = kotlin_kotlin.$_$.md;
  var getKClass = kotlin_kotlin.$_$.f;
  var Pair = kotlin_kotlin.$_$.hd;
  var LinkedHashMap = kotlin_kotlin.$_$.y4;
  var MutableMap = kotlin_kotlin.$_$.e5;
  var HashMap = kotlin_kotlin.$_$.w4;
  var LinkedHashSet = kotlin_kotlin.$_$.z4;
  var MutableSet = kotlin_kotlin.$_$.f5;
  var Set = kotlin_kotlin.$_$.g5;
  var HashSet = kotlin_kotlin.$_$.x4;
  var ArrayList = kotlin_kotlin.$_$.u4;
  var MutableList = kotlin_kotlin.$_$.d5;
  var List = kotlin_kotlin.$_$.a5;
  var Collection = kotlin_kotlin.$_$.v4;
  var copyToArray = kotlin_kotlin.$_$.z5;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.q2;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.p2;
  var Result = kotlin_kotlin.$_$.id;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var equals = kotlin_kotlin.$_$.c9;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var isBlank = kotlin_kotlin.$_$.jb;
  var toList = kotlin_kotlin.$_$.p7;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.l;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.r;
  var toHashSet = kotlin_kotlin.$_$.m7;
  var toBooleanArray = kotlin_kotlin.$_$.l7;
  var withIndex = kotlin_kotlin.$_$.v7;
  var to = kotlin_kotlin.$_$.me;
  var lazy_0 = kotlin_kotlin.$_$.he;
  var contentEquals = kotlin_kotlin.$_$.l5;
  var until = kotlin_kotlin.$_$.ua;
  var joinToString = kotlin_kotlin.$_$.n6;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var Long = kotlin_kotlin.$_$.ed;
  var Char = kotlin_kotlin.$_$.vc;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.e2;
  var Duration = kotlin_kotlin.$_$.uc;
  var Companion_getInstance = kotlin_kotlin.$_$.l4;
  var toIntOrNull = kotlin_kotlin.$_$.hc;
  var hashCode = kotlin_kotlin.$_$.j9;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.m;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.s;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.x;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.v;
  var isArray = kotlin_kotlin.$_$.l9;
  var arrayIterator = kotlin_kotlin.$_$.r8;
  var step = kotlin_kotlin.$_$.ta;
  var getValue = kotlin_kotlin.$_$.j6;
  var longArray = kotlin_kotlin.$_$.y9;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.n4;
  var get_lastIndex = kotlin_kotlin.$_$.p6;
  var countTrailingZeroBits = kotlin_kotlin.$_$.zd;
  var indexOf = kotlin_kotlin.$_$.k6;
  var contentToString = kotlin_kotlin.$_$.p5;
  var Enum = kotlin_kotlin.$_$.zc;
  var fillArrayVal = kotlin_kotlin.$_$.e9;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.q;
  var KTypeParameter = kotlin_kotlin.$_$.xa;
  var booleanArray = kotlin_kotlin.$_$.s8;
  var emptyMap = kotlin_kotlin.$_$.c6;
  var contentHashCode = kotlin_kotlin.$_$.o5;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.m4;
  var isCharArray = kotlin_kotlin.$_$.o9;
  var charArray = kotlin_kotlin.$_$.v8;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.f4;
  var isDoubleArray = kotlin_kotlin.$_$.q9;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.g4;
  var isFloatArray = kotlin_kotlin.$_$.r9;
  var isLongArray = kotlin_kotlin.$_$.u9;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.r4;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.q3;
  var ULongArray = kotlin_kotlin.$_$.rd;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.m3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.j3;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.o3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.k3;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.h4;
  var isIntArray = kotlin_kotlin.$_$.s9;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.q4;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.h3;
  var UIntArray = kotlin_kotlin.$_$.pd;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.d3;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.a3;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.f3;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.b3;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.i4;
  var isShortArray = kotlin_kotlin.$_$.v9;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.s4;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.z3;
  var UShortArray = kotlin_kotlin.$_$.td;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.v3;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.s3;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.x3;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.t3;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.e4;
  var isByteArray = kotlin_kotlin.$_$.n9;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.p4;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.y2;
  var UByteArray = kotlin_kotlin.$_$.nd;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.v2;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.r2;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.w2;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.s2;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.d4;
  var isBooleanArray = kotlin_kotlin.$_$.m9;
  var coerceAtLeast = kotlin_kotlin.$_$.na;
  var copyOf = kotlin_kotlin.$_$.t5;
  var copyOf_0 = kotlin_kotlin.$_$.v5;
  var copyOf_1 = kotlin_kotlin.$_$.w5;
  var copyOf_2 = kotlin_kotlin.$_$.r5;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.r3;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.n3;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.p3;
  var copyOf_3 = kotlin_kotlin.$_$.y5;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.i3;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.e3;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.g3;
  var copyOf_4 = kotlin_kotlin.$_$.q5;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.a4;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.w3;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.y3;
  var copyOf_5 = kotlin_kotlin.$_$.u5;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.z2;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.u2;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.x2;
  var copyOf_6 = kotlin_kotlin.$_$.s5;
  var Unit = kotlin_kotlin.$_$.vd;
  var trimIndent = kotlin_kotlin.$_$.rc;
  var equals_0 = kotlin_kotlin.$_$.eb;
  var charSequenceLength = kotlin_kotlin.$_$.x8;
  var charSequenceGet = kotlin_kotlin.$_$.w8;
  var toString_0 = kotlin_kotlin.$_$.m2;
  var titlecase = kotlin_kotlin.$_$.dc;
  var isLowerCase = kotlin_kotlin.$_$.mb;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.k4;
  var ULong = kotlin_kotlin.$_$.sd;
  var UInt = kotlin_kotlin.$_$.qd;
  var UShort = kotlin_kotlin.$_$.ud;
  var UByte = kotlin_kotlin.$_$.od;
  var mapOf = kotlin_kotlin.$_$.x6;
  var lastOrNull = kotlin_kotlin.$_$.s6;
  var get_lastIndex_0 = kotlin_kotlin.$_$.q6;
  var get_js = kotlin_kotlin.$_$.x9;
  var findAssociatedObject = kotlin_kotlin.$_$.d;
  var get_indices = kotlin_kotlin.$_$.m6;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var get_indices_0 = kotlin_kotlin.$_$.l6;
  var Companion_instance = kotlin_kotlin.$_$.o4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.n2;
  var createFailure = kotlin_kotlin.$_$.ae;
  //endregion
  //region block: pre-declaration
  setMetadataFor(SerializationStrategy, 'SerializationStrategy', interfaceMeta);
  setMetadataFor(DeserializationStrategy, 'DeserializationStrategy', interfaceMeta);
  setMetadataFor(KSerializer, 'KSerializer', interfaceMeta, VOID, [SerializationStrategy, DeserializationStrategy]);
  setMetadataFor(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(PolymorphicSerializer, 'PolymorphicSerializer', classMeta, AbstractPolymorphicSerializer);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta);
  setMetadataFor(SealedClassSerializer, 'SealedClassSerializer', classMeta, AbstractPolymorphicSerializer);
  setMetadataFor(StringFormat, 'StringFormat', interfaceMeta);
  setMetadataFor(BinaryFormat, 'BinaryFormat', interfaceMeta);
  setMetadataFor(SerializationException, 'SerializationException', classMeta, IllegalArgumentException, VOID, SerializationException_init_$Create$);
  setMetadataFor(UnknownFieldException, 'UnknownFieldException', classMeta, SerializationException);
  setMetadataFor(MissingFieldException, 'MissingFieldException', classMeta, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  setMetadataFor(SerialDescriptor, 'SerialDescriptor', interfaceMeta);
  setMetadataFor(ContextDescriptor, 'ContextDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(elementDescriptors$1$1, VOID, classMeta);
  setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta);
  setMetadataFor(elementNames$1$1, VOID, classMeta);
  setMetadataFor(_no_name_provided__qut3iv_1, VOID, classMeta);
  setMetadataFor(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder', classMeta);
  setMetadataFor(CachedNames, 'CachedNames', interfaceMeta);
  setMetadataFor(SerialDescriptorImpl, 'SerialDescriptorImpl', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(SerialKind, 'SerialKind', classMeta);
  setMetadataFor(ENUM, 'ENUM', objectMeta, SerialKind);
  setMetadataFor(CONTEXTUAL, 'CONTEXTUAL', objectMeta, SerialKind);
  setMetadataFor(PrimitiveKind, 'PrimitiveKind', classMeta, SerialKind);
  setMetadataFor(BOOLEAN, 'BOOLEAN', objectMeta, PrimitiveKind);
  setMetadataFor(BYTE, 'BYTE', objectMeta, PrimitiveKind);
  setMetadataFor(CHAR, 'CHAR', objectMeta, PrimitiveKind);
  setMetadataFor(SHORT, 'SHORT', objectMeta, PrimitiveKind);
  setMetadataFor(INT, 'INT', objectMeta, PrimitiveKind);
  setMetadataFor(LONG, 'LONG', objectMeta, PrimitiveKind);
  setMetadataFor(FLOAT, 'FLOAT', objectMeta, PrimitiveKind);
  setMetadataFor(DOUBLE, 'DOUBLE', objectMeta, PrimitiveKind);
  setMetadataFor(STRING, 'STRING', objectMeta, PrimitiveKind);
  setMetadataFor(StructureKind, 'StructureKind', classMeta, SerialKind);
  setMetadataFor(CLASS, 'CLASS', objectMeta, StructureKind);
  setMetadataFor(LIST, 'LIST', objectMeta, StructureKind);
  setMetadataFor(MAP, 'MAP', objectMeta, StructureKind);
  setMetadataFor(OBJECT, 'OBJECT', objectMeta, StructureKind);
  setMetadataFor(PolymorphicKind, 'PolymorphicKind', classMeta, SerialKind);
  setMetadataFor(SEALED, 'SEALED', objectMeta, PolymorphicKind);
  setMetadataFor(OPEN, 'OPEN', objectMeta, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.ki(this);
  }
  setMetadataFor(Decoder, 'Decoder', interfaceMeta);
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.gm(descriptor, index, deserializer, previousValue) : $super.gm.call(this, descriptor, index, deserializer, previousValue);
  }
  setMetadataFor(CompositeDecoder, 'CompositeDecoder', interfaceMeta);
  setMetadataFor(AbstractDecoder, 'AbstractDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.ul(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.ji(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.ii().uj();
    if (isNullabilitySupported) {
      return this.mn(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.pm();
    } else {
      this.pn();
      this.mn(serializer, value);
    }
  }
  setMetadataFor(Encoder, 'Encoder', interfaceMeta);
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  setMetadataFor(CompositeEncoder, 'CompositeEncoder', interfaceMeta);
  setMetadataFor(AbstractEncoder, 'AbstractEncoder', classMeta, VOID, [Encoder, CompositeEncoder]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(NothingSerializer_0, 'NothingSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DurationSerializer, 'DurationSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ListLikeDescriptor, 'ListLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(ArrayListClassDesc, 'ArrayListClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(HashSetClassDesc, 'HashSetClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(MapLikeDescriptor, 'MapLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(HashMapClassDesc, 'HashMapClassDesc', classMeta, MapLikeDescriptor);
  setMetadataFor(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', classMeta, MapLikeDescriptor);
  setMetadataFor(ArrayClassDesc, 'ArrayClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', classMeta, ListLikeDescriptor);
  setMetadataFor(AbstractCollectionSerializer, 'AbstractCollectionSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(CollectionLikeSerializer, 'CollectionLikeSerializer', classMeta, AbstractCollectionSerializer);
  setMetadataFor(CollectionSerializer, 'CollectionSerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(ArrayListSerializer, 'ArrayListSerializer', classMeta, CollectionSerializer);
  setMetadataFor(HashSetSerializer, 'HashSetSerializer', classMeta, CollectionSerializer);
  setMetadataFor(LinkedHashSetSerializer, 'LinkedHashSetSerializer', classMeta, CollectionSerializer);
  setMetadataFor(MapLikeSerializer, 'MapLikeSerializer', classMeta, AbstractCollectionSerializer);
  setMetadataFor(HashMapSerializer, 'HashMapSerializer', classMeta, MapLikeSerializer);
  setMetadataFor(LinkedHashMapSerializer, 'LinkedHashMapSerializer', classMeta, MapLikeSerializer);
  setMetadataFor(ReferenceArraySerializer, 'ReferenceArraySerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(PrimitiveArraySerializer, 'PrimitiveArraySerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(ElementMarker, 'ElementMarker', classMeta);
  setMetadataFor(EnumSerializer, 'EnumSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(EnumDescriptor, 'EnumDescriptor', classMeta, PluginGeneratedSerialDescriptor);
  setMetadataFor(InlineClassDescriptor, 'InlineClassDescriptor', classMeta, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  setMetadataFor(GeneratedSerializer, 'GeneratedSerializer', interfaceMeta, VOID, [KSerializer]);
  setMetadataFor(InlinePrimitiveDescriptor$1, VOID, classMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(NoOpEncoder, 'NoOpEncoder', objectMeta, AbstractEncoder);
  setMetadataFor(NothingSerialDescriptor, 'NothingSerialDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(NullableSerializer, 'NullableSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(SerialDescriptorForNullable, 'SerialDescriptorForNullable', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(ObjectSerializer, 'ObjectSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(SerializerFactory, 'SerializerFactory', interfaceMeta);
  setMetadataFor(CharArraySerializer_0, 'CharArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(DoubleArraySerializer_0, 'DoubleArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(FloatArraySerializer_0, 'FloatArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(LongArraySerializer_0, 'LongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ULongArraySerializer_0, 'ULongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(IntArraySerializer_0, 'IntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UIntArraySerializer_0, 'UIntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ShortArraySerializer_0, 'ShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UShortArraySerializer_0, 'UShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ByteArraySerializer_0, 'ByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UByteArraySerializer_0, 'UByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(BooleanArraySerializer_0, 'BooleanArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(CharArrayBuilder, 'CharArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(DoubleArrayBuilder, 'DoubleArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(FloatArrayBuilder, 'FloatArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(LongArrayBuilder, 'LongArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ULongArrayBuilder, 'ULongArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(IntArrayBuilder, 'IntArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UIntArrayBuilder, 'UIntArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ShortArrayBuilder, 'ShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UShortArrayBuilder, 'UShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ByteArrayBuilder, 'ByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UByteArrayBuilder, 'UByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(BooleanArrayBuilder, 'BooleanArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(StringSerializer, 'StringSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(CharSerializer, 'CharSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DoubleSerializer, 'DoubleSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(FloatSerializer, 'FloatSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(LongSerializer, 'LongSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(IntSerializer, 'IntSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ShortSerializer, 'ShortSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ByteSerializer, 'ByteSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(BooleanSerializer, 'BooleanSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UnitSerializer, 'UnitSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(TaggedDecoder, 'TaggedDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
  setMetadataFor(NamedValueDecoder, 'NamedValueDecoder', classMeta, TaggedDecoder);
  setMetadataFor(MapEntry, 'MapEntry', classMeta, VOID, [Entry]);
  setMetadataFor(KeyValueSerializer, 'KeyValueSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(MapEntrySerializer_0, 'MapEntrySerializer', classMeta, KeyValueSerializer);
  setMetadataFor(PairSerializer_0, 'PairSerializer', classMeta, KeyValueSerializer);
  setMetadataFor(TripleSerializer_0, 'TripleSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(ULongSerializer, 'ULongSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UIntSerializer, 'UIntSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UShortSerializer, 'UShortSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UByteSerializer, 'UByteSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(SerializersModule, 'SerializersModule', classMeta);
  setMetadataFor(SerialModuleImpl, 'SerialModuleImpl', classMeta, SerializersModule);
  setMetadataFor(ContextualProvider, 'ContextualProvider', classMeta);
  setMetadataFor(Argless, 'Argless', classMeta, ContextualProvider);
  setMetadataFor(WithTypeArguments, 'WithTypeArguments', classMeta, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.h12(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  setMetadataFor(SerializersModuleCollector, 'SerializersModuleCollector', interfaceMeta);
  setMetadataFor(SerializableWith, 'SerializableWith', classMeta, VOID, VOID, VOID, 0);
  setMetadataFor(createCache$1, VOID, classMeta);
  setMetadataFor(createParametrizedCache$1, VOID, classMeta);
  //endregion
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, $this) {
    PolymorphicSerializer.call($this, baseClass);
    $this.mi_1 = asList(classAnnotations);
    return $this;
  }
  function PolymorphicSerializer_init_$Create$(baseClass, classAnnotations) {
    return PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, objectCreate(protoOf(PolymorphicSerializer)));
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.wi('type', serializer_2(StringCompanionObject_instance).ii());
      $this$buildSerialDescriptor.wi('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.li_1.z5() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.qi_1 = this$0.mi_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.li_1);
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.li_1 = baseClass;
    this.mi_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ni_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).xi = function () {
    return this.li_1;
  };
  protoOf(PolymorphicSerializer).ii = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ni_1;
    descriptor$factory();
    return this_0.f2();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + this.li_1 + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.aj(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.xi());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.zi(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.xi());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function descriptor$factory() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ii();
    }, null);
  }
  function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
    SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
    $this.cj_1 = asList(classAnnotations);
    return $this;
  }
  function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this$0.fj_1.b2().u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlinx.serialization.SealedClassSerializer.descriptor$delegate.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var name = element.e2();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element.f2();
        $this$buildSerialDescriptor.wi(name, serializer.ii());
      }
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.wi('type', serializer_2(StringCompanionObject_instance).ii());
      var tmp = 'kotlinx.serialization.Sealed<' + this$0.bj_1.z5() + '>';
      var tmp_0 = CONTEXTUAL_getInstance();
      var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
      $this$buildSerialDescriptor.wi('value', elementDescriptor);
      $this$buildSerialDescriptor.qi_1 = this$0.cj_1;
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = SEALED_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function _no_name_provided__qut3iv($this) {
    this.gj_1 = $this;
  }
  protoOf(_no_name_provided__qut3iv).hj = function () {
    return this.gj_1.u();
  };
  protoOf(_no_name_provided__qut3iv).ij = function (element) {
    // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
    return element.f2().ii().jj();
  };
  protoOf(_no_name_provided__qut3iv).kj = function (element) {
    return this.ij((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
    AbstractPolymorphicSerializer.call(this);
    this.bj_1 = baseClass;
    this.cj_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.dj_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException_init_$Create$('All subclasses of sealed class ' + this.bj_1.z5() + ' should be marked @Serializable');
    }
    this.ej_1 = toMap(zip(subclasses, subclassSerializers));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.aggregate' call
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = this.ej_1.b2();
    // Inline function 'kotlin.collections.aggregateTo' call
    var this_1 = new _no_name_provided__qut3iv(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_1.hj();
    while (tmp0_iterator.v()) {
      var e = tmp0_iterator.w();
      var key = this_1.kj(e);
      var accumulator = destination.m2(key);
      // Inline function 'kotlin.collections.set' call
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      accumulator == null && !destination.j2(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + this.bj_1 + "' have the same serial name '" + key + "':" + (" '" + accumulator.e2() + "', '" + e.e2() + "'");
        throw IllegalStateException_init_$Create$(toString(message));
      }
      destination.c2(key, e);
    }
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.n()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator_0 = destination.b2().u();
    while (tmp0_iterator_0.v()) {
      var element = tmp0_iterator_0.w();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_2 = element.e2();
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      var tmp$ret$7 = element.f2().f2();
      destination_0.c2(tmp_2, tmp$ret$7);
    }
    tmp_1.fj_1 = destination_0;
  }
  protoOf(SealedClassSerializer).xi = function () {
    return this.bj_1;
  };
  protoOf(SealedClassSerializer).ii = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.dj_1;
    descriptor$factory_0();
    return this_0.f2();
  };
  protoOf(SealedClassSerializer).zi = function (decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.fj_1;
    var tmp0_elvis_lhs = (isInterface(this_0, Map) ? this_0 : THROW_CCE()).m2(klassName);
    return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).zi.call(this, decoder, klassName) : tmp0_elvis_lhs;
  };
  protoOf(SealedClassSerializer).aj = function (encoder, value) {
    var tmp0_elvis_lhs = this.ej_1.m2(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).aj.call(this, encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  };
  function descriptor$factory_0() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ii();
    }, null);
  }
  function StringFormat() {
  }
  function BinaryFormat() {
  }
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.n() === 1 ? "Field '" + missingFields.f1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + missingFields + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.pj_1 = missingFields;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator = typeArguments.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.w();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp$ret$0 = serializer(_this__u8e3s4, item);
        destination.r(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_0 = typeArguments.u();
      while (tmp0_iterator_0.v()) {
        var item_0 = tmp0_iterator_0.w();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$3 = tmp_0;
        destination_0.r(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(List))) ? true : _this__u8e3s4.equals(getKClass(MutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.f1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.f1(0));
    } else if ((_this__u8e3s4.equals(getKClass(Set)) ? true : _this__u8e3s4.equals(getKClass(MutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.f1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.f1(0), serializers.f1(1));
    } else if ((_this__u8e3s4.equals(getKClass(Map)) ? true : _this__u8e3s4.equals(getKClass(MutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.f1(0), serializers.f1(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.f1(0), serializers.f1(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.f1(0), serializers.f1(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.f1(0), serializers.f1(1), serializers.f1(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.f1(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.p6();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.o6();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      var tmp$ret$0 = typeOrThrow(item);
      destination.r(tmp$ret$0);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.b1()) {
      tmp = findCachedSerializer(rootClass, isNullable);
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_0;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_0 = null;
      } else {
        var tmp_1 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_0 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
      }
      tmp = tmp_0;
    }
    var cachedSerializer = tmp;
    if (cachedSerializer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return cachedSerializer;
    }
    var tmp_2;
    if (typeArguments.b1()) {
      tmp_2 = _this__u8e3s4.rj(rootClass);
    } else {
      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      var serializers = tmp_3;
      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      tmp_2 = tmp2_elvis_lhs == null ? _this__u8e3s4.qj(rootClass, serializers) : tmp2_elvis_lhs;
    }
    var contextualSerializer = tmp_2;
    var tmp_4;
    if (contextualSerializer == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_4 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp4_safe_receiver = tmp_4;
    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializer_0(type) {
    return serializer(EmptySerializersModule_0(), type);
  }
  function serializer_1(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.f1(0).n6();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().sj(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().sj(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().tj(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().tj(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    return serializerOrNull(it);
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_safe_receiver = serializerOrNull(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.f1(0).n6();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.f1(0).n6();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.ii().uj()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function serializer_2(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_5(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_16(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function ContextDescriptor(original, kClass) {
    this.vj_1 = original;
    this.wj_1 = kClass;
    this.xj_1 = this.vj_1.jj() + '<' + this.wj_1.z5() + '>';
  }
  protoOf(ContextDescriptor).yj = function () {
    return this.vj_1.yj();
  };
  protoOf(ContextDescriptor).zj = function () {
    return this.vj_1.zj();
  };
  protoOf(ContextDescriptor).ak = function () {
    return this.vj_1.ak();
  };
  protoOf(ContextDescriptor).uj = function () {
    return this.vj_1.uj();
  };
  protoOf(ContextDescriptor).bk = function () {
    return this.vj_1.bk();
  };
  protoOf(ContextDescriptor).ck = function (index) {
    return this.vj_1.ck(index);
  };
  protoOf(ContextDescriptor).dk = function (index) {
    return this.vj_1.dk(index);
  };
  protoOf(ContextDescriptor).ek = function (name) {
    return this.vj_1.ek(name);
  };
  protoOf(ContextDescriptor).fk = function (index) {
    return this.vj_1.fk(index);
  };
  protoOf(ContextDescriptor).gk = function (index) {
    return this.vj_1.gk(index);
  };
  protoOf(ContextDescriptor).jj = function () {
    return this.xj_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.vj_1, another.vj_1) ? another.wj_1.equals(this.wj_1) : false;
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.wj_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.xj_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + this.wj_1 + ', original: ' + this.vj_1 + ')';
  };
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.rj(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ii();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.wj_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.hk_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(_this__u8e3s4);
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_1(_this__u8e3s4);
  }
  function elementDescriptors$1$1($this_elementDescriptors) {
    this.lk_1 = $this_elementDescriptors;
    this.kk_1 = $this_elementDescriptors.zj();
  }
  protoOf(elementDescriptors$1$1).v = function () {
    return this.kk_1 > 0;
  };
  protoOf(elementDescriptors$1$1).w = function () {
    var tmp = this.lk_1.zj();
    var tmp1 = this.kk_1;
    this.kk_1 = tmp1 - 1 | 0;
    return this.lk_1.dk(tmp - tmp1 | 0);
  };
  function _no_name_provided__qut3iv_0($this_elementDescriptors) {
    this.mk_1 = $this_elementDescriptors;
  }
  protoOf(_no_name_provided__qut3iv_0).u = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1$1(this.mk_1);
  };
  function elementNames$1$1($this_elementNames) {
    this.ok_1 = $this_elementNames;
    this.nk_1 = $this_elementNames.zj();
  }
  protoOf(elementNames$1$1).v = function () {
    return this.nk_1 > 0;
  };
  protoOf(elementNames$1$1).w = function () {
    var tmp = this.ok_1.zj();
    var tmp1 = this.nk_1;
    this.nk_1 = tmp1 - 1 | 0;
    return this.ok_1.fk(tmp - tmp1 | 0);
  };
  function _no_name_provided__qut3iv_1($this_elementNames) {
    this.pk_1 = $this_elementNames;
  }
  protoOf(_no_name_provided__qut3iv_1).u = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1$1(this.pk_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!equals(kind, CLASS_getInstance())) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.ri_1.n(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.oi_1 = serialName;
    this.pi_1 = false;
    this.qi_1 = emptyList();
    this.ri_1 = ArrayList_init_$Create$_0();
    this.si_1 = HashSet_init_$Create$();
    this.ti_1 = ArrayList_init_$Create$_0();
    this.ui_1 = ArrayList_init_$Create$_0();
    this.vi_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).qk = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.si_1.r(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.oi_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.ri_1.r(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.ti_1.r(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.ui_1.r(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.vi_1.r(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).wi = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.qk(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.qk.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.ri_1.n(), toList(typeParameters), sdBuilder);
  }
  function _get__hashCode__tgwhef($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.cl_1;
    _hashCode$factory();
    return this_0.f2();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.bl_1);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.fk(it) + ': ' + this$0.dk(it).jj();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.rk_1 = serialName;
    this.sk_1 = kind;
    this.tk_1 = elementsCount;
    this.uk_1 = builder.qi_1;
    this.vk_1 = toHashSet(builder.ri_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.ri_1;
    tmp.wk_1 = copyToArray(this_0);
    this.xk_1 = compactArray(builder.ti_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.ui_1;
    tmp_0.yk_1 = copyToArray(this_1);
    this.zk_1 = toBooleanArray(builder.vi_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.wk_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.cd_1, item.bd_1);
      destination.r(tmp$ret$2);
    }
    tmp_1.al_1 = toMap(destination);
    this.bl_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.cl_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).jj = function () {
    return this.rk_1;
  };
  protoOf(SerialDescriptorImpl).bk = function () {
    return this.sk_1;
  };
  protoOf(SerialDescriptorImpl).zj = function () {
    return this.tk_1;
  };
  protoOf(SerialDescriptorImpl).yj = function () {
    return this.uk_1;
  };
  protoOf(SerialDescriptorImpl).dl = function () {
    return this.vk_1;
  };
  protoOf(SerialDescriptorImpl).fk = function (index) {
    return getChecked(this.wk_1, index);
  };
  protoOf(SerialDescriptorImpl).ek = function (name) {
    var tmp0_elvis_lhs = this.al_1.m2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SerialDescriptorImpl).ck = function (index) {
    return getChecked(this.yk_1, index);
  };
  protoOf(SerialDescriptorImpl).dk = function (index) {
    return getChecked(this.xk_1, index);
  };
  protoOf(SerialDescriptorImpl).gk = function (index) {
    return getChecked_0(this.zk_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.jj() === other.jj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.bl_1, other.bl_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zj() === other.zj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zj();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.dk(index).jj() === other.dk(index).jj())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.dk(index).bk(), other.dk(index).bk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.tk_1);
    var tmp_0 = this.rk_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef(receiver);
    }, null);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).z5());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).el = function () {
    throw SerializationException_init_$Create$_0('' + getKClassFromExpression(this) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).fl = function () {
    return true;
  };
  protoOf(AbstractDecoder).gl = function () {
    return null;
  };
  protoOf(AbstractDecoder).hl = function () {
    var tmp = this.el();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).il = function () {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).jl = function () {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).kl = function () {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).ll = function () {
    var tmp = this.el();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).ml = function () {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).nl = function () {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).ol = function () {
    var tmp = this.el();
    return tmp instanceof Char ? tmp.v8_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).pl = function () {
    var tmp = this.el();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).ql = function (enumDescriptor) {
    var tmp = this.el();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).rl = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).sl = function (deserializer, previousValue) {
    return this.tl(deserializer);
  };
  protoOf(AbstractDecoder).ul = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).vl = function (descriptor) {
  };
  protoOf(AbstractDecoder).wl = function (descriptor, index) {
    return this.hl();
  };
  protoOf(AbstractDecoder).xl = function (descriptor, index) {
    return this.il();
  };
  protoOf(AbstractDecoder).yl = function (descriptor, index) {
    return this.jl();
  };
  protoOf(AbstractDecoder).zl = function (descriptor, index) {
    return this.kl();
  };
  protoOf(AbstractDecoder).am = function (descriptor, index) {
    return this.ll();
  };
  protoOf(AbstractDecoder).bm = function (descriptor, index) {
    return this.ml();
  };
  protoOf(AbstractDecoder).cm = function (descriptor, index) {
    return this.nl();
  };
  protoOf(AbstractDecoder).dm = function (descriptor, index) {
    return this.ol();
  };
  protoOf(AbstractDecoder).em = function (descriptor, index) {
    return this.pl();
  };
  protoOf(AbstractDecoder).fm = function (descriptor, index) {
    return this.rl(descriptor.dk(index));
  };
  protoOf(AbstractDecoder).gm = function (descriptor, index, deserializer, previousValue) {
    return this.sl(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).im = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.ii().uj();
    var tmp;
    if (isNullabilitySupported ? true : this.fl()) {
      // Inline function 'kotlinx.serialization.encoding.AbstractDecoder.decodeNullableSerializableElement.<anonymous>' call
      tmp = this.sl(deserializer, previousValue);
    } else {
      tmp = this.gl();
    }
    return tmp;
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).ul = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).vl = function (descriptor) {
  };
  protoOf(AbstractEncoder).nm = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).om = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + getKClassFromExpression(value) + ' is not supported by ' + getKClassFromExpression(this) + ' encoder');
  };
  protoOf(AbstractEncoder).pm = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).qm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).rm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).sm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).tm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).um = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).vm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).wm = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).xm = function (value) {
    return this.om(new Char(value));
  };
  protoOf(AbstractEncoder).ym = function (value) {
    return this.om(value);
  };
  protoOf(AbstractEncoder).zm = function (enumDescriptor, index) {
    return this.om(index);
  };
  protoOf(AbstractEncoder).an = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).bn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.qm(value);
    }
  };
  protoOf(AbstractEncoder).cn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.rm(value);
    }
  };
  protoOf(AbstractEncoder).dn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.sm(value);
    }
  };
  protoOf(AbstractEncoder).en = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.tm(value);
    }
  };
  protoOf(AbstractEncoder).fn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.um(value);
    }
  };
  protoOf(AbstractEncoder).gn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.vm(value);
    }
  };
  protoOf(AbstractEncoder).hn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.wm(value);
    }
  };
  protoOf(AbstractEncoder).in = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.xm(value);
    }
  };
  protoOf(AbstractEncoder).jn = function (descriptor, index, value) {
    if (this.nm(descriptor, index)) {
      this.ym(value);
    }
  };
  protoOf(AbstractEncoder).kn = function (descriptor, index) {
    return this.nm(descriptor, index) ? this.an(descriptor.dk(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).ln = function (descriptor, index, serializer, value) {
    if (this.nm(descriptor, index)) {
      this.mn(serializer, value);
    }
  };
  protoOf(AbstractEncoder).nn = function (descriptor, index, serializer, value) {
    if (this.nm(descriptor, index)) {
      this.on(serializer, value);
    }
  };
  function Decoder() {
  }
  function Companion() {
    this.sn_1 = -1;
    this.tn_1 = -3;
  }
  var Companion_instance_0;
  function Companion_getInstance_6() {
    return Companion_instance_0;
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.em($this.ii(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.hm($this.ii(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).yi = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.ii();
    var composite = encoder.ul(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.jn(this.ii(), 0, actualSerializer.ii().jj());
    var tmp = this.ii();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.ln(tmp, 1, tmp$ret$0, value);
    composite.vl(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).ji = function (encoder, value) {
    return this.yi(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).ki = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ii();
    var composite = decoder.ul(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.km()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.lm(this.ii());
        if (index === -1) {
          break mainLoop;
        } else {
          if (index === 0) {
            klassName = composite.em(this.ii(), index);
          } else {
            if (index === 1) {
              var tmp$ret$2;
              $l$block_0: {
                // Inline function 'kotlin.requireNotNull' call
                var value_0 = klassName;
                // Inline function 'kotlin.contracts.contract' call
                if (value_0 == null) {
                  // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                  var message = 'Cannot read polymorphic value before its type token';
                  throw IllegalArgumentException_init_$Create$(toString(message));
                } else {
                  tmp$ret$2 = value_0;
                  break $l$block_0;
                }
              }
              klassName = tmp$ret$2;
              var serializer = findPolymorphicSerializer_0(this, composite, klassName);
              value = composite.hm(this.ii(), index, serializer);
            } else {
              var tmp0_elvis_lhs = klassName;
              throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
            }
          }
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.vl(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).zi = function (decoder, klassName) {
    return decoder.jm().un(this.xi(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).aj = function (encoder, value) {
    return encoder.jm().vn(this.xi(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.z5();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? '' + subClass : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the polymorphic scope of '" + baseClass.z5() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.z5() + "' has to be sealed and '@Serializable'."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.wn_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).ii = function () {
    return this.wn_1;
  };
  protoOf(NothingSerializer_0).xn = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).ji = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.xn(encoder, tmp);
  };
  protoOf(NothingSerializer_0).ki = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.yn_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).ii = function () {
    return this.yn_1;
  };
  protoOf(DurationSerializer).zn = function (encoder, value) {
    encoder.ym(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).ji = function (encoder, value) {
    return this.zn(encoder, value instanceof Duration ? value.xf_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).ao = function (decoder) {
    return Companion_getInstance().wf(decoder.pl());
  };
  protoOf(DurationSerializer).ki = function (decoder) {
    return new Duration(this.ao(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).jj = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).jj = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).jj = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).jj = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.do_1 = elementDescriptor;
    this.eo_1 = 1;
  }
  protoOf(ListLikeDescriptor).bk = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).zj = function () {
    return this.eo_1;
  };
  protoOf(ListLikeDescriptor).fk = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).ek = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).gk = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).ck = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).dk = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.do_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.do_1, other.do_1) ? this.jj() === other.jj() : false)
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.do_1), 31) + getStringHashCode(this.jj()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.jj() + '(' + this.do_1 + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.jo_1 = serialName;
    this.ko_1 = keyDescriptor;
    this.lo_1 = valueDescriptor;
    this.mo_1 = 2;
  }
  protoOf(MapLikeDescriptor).jj = function () {
    return this.jo_1;
  };
  protoOf(MapLikeDescriptor).bk = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).zj = function () {
    return this.mo_1;
  };
  protoOf(MapLikeDescriptor).fk = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).ek = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).gk = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).ck = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).dk = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.jj() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.ko_1;
        break;
      case 1:
        tmp = this.lo_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.jj() === other.jj()))
      return false;
    if (!equals(this.ko_1, other.ko_1))
      return false;
    if (!equals(this.lo_1, other.lo_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.jj());
    result = imul(31, result) + hashCode(this.ko_1) | 0;
    result = imul(31, result) + hashCode(this.lo_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.jj() + '(' + this.ko_1 + ', ' + this.lo_1 + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.ro_1 = primitive.jj() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).jj = function () {
    return this.ro_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.to_1 = new ArrayListClassDesc(element.ii());
  }
  protoOf(ArrayListSerializer).ii = function () {
    return this.to_1;
  };
  protoOf(ArrayListSerializer).uo = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).vo = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(ArrayListSerializer).wo = function (_this__u8e3s4) {
    return this.vo(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).xo = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).yo = function (_this__u8e3s4) {
    return this.xo(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).zo = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).ap = function (_this__u8e3s4) {
    return this.zo((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, List) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).bp = function (_this__u8e3s4, size) {
    return _this__u8e3s4.u2(size);
  };
  protoOf(ArrayListSerializer).cp = function (_this__u8e3s4, size) {
    return this.bp(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).dp = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.n1(index, element);
  };
  protoOf(ArrayListSerializer).ep = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.dp(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.pp_1 = new HashSetClassDesc(eSerializer.ii());
  }
  protoOf(HashSetSerializer).ii = function () {
    return this.pp_1;
  };
  protoOf(HashSetSerializer).uo = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).qp = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(HashSetSerializer).wo = function (_this__u8e3s4) {
    return this.qp(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).rp = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).yo = function (_this__u8e3s4) {
    return this.rp(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).sp = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).ap = function (_this__u8e3s4) {
    return this.sp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).tp = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).cp = function (_this__u8e3s4, size) {
    return this.tp(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).up = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.r(element);
  };
  protoOf(HashSetSerializer).ep = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.up(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.wp_1 = new LinkedHashSetClassDesc(eSerializer.ii());
  }
  protoOf(LinkedHashSetSerializer).ii = function () {
    return this.wp_1;
  };
  protoOf(LinkedHashSetSerializer).uo = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).xp = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(LinkedHashSetSerializer).wo = function (_this__u8e3s4) {
    return this.xp(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).yp = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).yo = function (_this__u8e3s4) {
    return this.yp(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).sp = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).ap = function (_this__u8e3s4) {
    return this.sp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).zp = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).cp = function (_this__u8e3s4, size) {
    return this.zp(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).aq = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.r(element);
  };
  protoOf(LinkedHashSetSerializer).ep = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.aq(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.dq_1 = new HashMapClassDesc(kSerializer.ii(), vSerializer.ii());
  }
  protoOf(HashMapSerializer).ii = function () {
    return this.dq_1;
  };
  protoOf(HashMapSerializer).eq = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(HashMapSerializer).fq = function (_this__u8e3s4) {
    return this.eq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).gq = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.b2().u();
  };
  protoOf(HashMapSerializer).hq = function (_this__u8e3s4) {
    return this.gq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).uo = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).iq = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n(), 2);
  };
  protoOf(HashMapSerializer).wo = function (_this__u8e3s4) {
    return this.iq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).jq = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).yo = function (_this__u8e3s4) {
    return this.jq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).kq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).ap = function (_this__u8e3s4) {
    return this.kq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).lq = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).cp = function (_this__u8e3s4, size) {
    return this.lq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.sq_1 = new LinkedHashMapClassDesc(kSerializer.ii(), vSerializer.ii());
  }
  protoOf(LinkedHashMapSerializer).ii = function () {
    return this.sq_1;
  };
  protoOf(LinkedHashMapSerializer).eq = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(LinkedHashMapSerializer).fq = function (_this__u8e3s4) {
    return this.eq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).gq = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.b2().u();
  };
  protoOf(LinkedHashMapSerializer).hq = function (_this__u8e3s4) {
    return this.gq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).uo = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).tq = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n(), 2);
  };
  protoOf(LinkedHashMapSerializer).wo = function (_this__u8e3s4) {
    return this.tq(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).uq = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).yo = function (_this__u8e3s4) {
    return this.uq(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).kq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).ap = function (_this__u8e3s4) {
    return this.kq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).vq = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).cp = function (_this__u8e3s4, size) {
    return this.vq(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.xq_1 = kClass;
    this.yq_1 = new ArrayClassDesc(eSerializer.ii());
  }
  protoOf(ReferenceArraySerializer).ii = function () {
    return this.yq_1;
  };
  protoOf(ReferenceArraySerializer).zq = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).fq = function (_this__u8e3s4) {
    return this.zq((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).ar = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).hq = function (_this__u8e3s4) {
    return this.ar((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).uo = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).br = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(ReferenceArraySerializer).wo = function (_this__u8e3s4) {
    return this.br(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).cr = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.xq_1);
  };
  protoOf(ReferenceArraySerializer).yo = function (_this__u8e3s4) {
    return this.cr(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).dr = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).ap = function (_this__u8e3s4) {
    return this.dr((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).er = function (_this__u8e3s4, size) {
    return _this__u8e3s4.u2(size);
  };
  protoOf(ReferenceArraySerializer).cp = function (_this__u8e3s4, size) {
    return this.er(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).fr = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.n1(index, element);
  };
  protoOf(ReferenceArraySerializer).ep = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.fr(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).gp = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(CollectionSerializer).fq = function (_this__u8e3s4) {
    return this.gp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).hp = function (_this__u8e3s4) {
    return _this__u8e3s4.u();
  };
  protoOf(CollectionSerializer).hq = function (_this__u8e3s4) {
    return this.hp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.mq_1 = keySerializer;
    this.nq_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).oq = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.o8_1;
    var last = progression.p8_1;
    var step_0 = progression.q8_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.pq(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).kp = function (decoder, builder, startIndex, size) {
    return this.oq(decoder, (!(builder == null) ? isInterface(builder, MutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).pq = function (decoder, index, builder, checkIndex) {
    var key = decoder.hm(this.ii(), index, this.mq_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.lm(this.ii());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.j2(key)) {
      var tmp_2 = this.nq_1.ii().bk();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.gm(this.ii(), vIndex, this.nq_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.hm(this.ii(), vIndex, this.nq_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.c2(key, value);
  };
  protoOf(MapLikeSerializer).lp = function (decoder, index, builder, checkIndex) {
    return this.pq(decoder, index, (!(builder == null) ? isInterface(builder, MutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).jp = function (encoder, value) {
    var size = this.fq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.ii();
    var composite = encoder.qn(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.hq(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.e2();
      // Inline function 'kotlin.collections.component2' call
      var v = element.f2();
      var tmp = this.ii();
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      composite.ln(tmp, tmp0, this.mq_1, k);
      var tmp_0 = this.ii();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      composite.ln(tmp_0, tmp1, this.nq_1, v);
    }
    composite.vl(descriptor);
  };
  protoOf(MapLikeSerializer).ji = function (encoder, value) {
    return this.jp(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.ip_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).jp = function (encoder, value) {
    var size = this.fq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.ii();
    var composite = encoder.qn(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.hq(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.ln(this.ii(), index, this.ip_1, iterator.w());
      }
       while (inductionVariable < size);
    composite.vl(descriptor);
  };
  protoOf(CollectionLikeSerializer).ji = function (encoder, value) {
    return this.jp(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).kp = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.lp(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).lp = function (decoder, index, builder, checkIndex) {
    this.ep(builder, index, decoder.hm(this.ii(), index, this.ip_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.mm($this.ii());
    $this.cp(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).np = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.ap(previous);
    var builder = tmp1_elvis_lhs == null ? this.uo() : tmp1_elvis_lhs;
    var startIndex = this.wo(builder);
    var compositeDecoder = decoder.ul(this.ii());
    if (compositeDecoder.km()) {
      this.kp(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.lm(this.ii());
        if (index === -1)
          break $l$loop;
        this.mp(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.vl(this.ii());
    return this.yo(builder);
  };
  protoOf(AbstractCollectionSerializer).ki = function (decoder) {
    return this.np(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).mp = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.lp(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.lp.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.hr_1 = new PrimitiveArrayDescriptor(primitiveSerializer.ii());
  }
  protoOf(PrimitiveArraySerializer).ii = function () {
    return this.hr_1;
  };
  protoOf(PrimitiveArraySerializer).ir = function (_this__u8e3s4) {
    return _this__u8e3s4.jr();
  };
  protoOf(PrimitiveArraySerializer).wo = function (_this__u8e3s4) {
    return this.ir(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).kr = function (_this__u8e3s4) {
    return _this__u8e3s4.lr();
  };
  protoOf(PrimitiveArraySerializer).yo = function (_this__u8e3s4) {
    return this.kr(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).mr = function (_this__u8e3s4, size) {
    return _this__u8e3s4.u2(size);
  };
  protoOf(PrimitiveArraySerializer).cp = function (_this__u8e3s4, size) {
    return this.mr(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).nr = function (_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).hq = function (_this__u8e3s4) {
    return this.nr((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).or = function (_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).ep = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.or(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).uo = function () {
    return this.ap(this.pr());
  };
  protoOf(PrimitiveArraySerializer).sr = function (encoder, value) {
    var size = this.fq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.hr_1;
    var composite = encoder.qn(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.rr(composite, value, size);
    composite.vl(descriptor);
  };
  protoOf(PrimitiveArraySerializer).ji = function (encoder, value) {
    return this.sr(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).jp = function (encoder, value) {
    return this.sr(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).ki = function (decoder) {
    return this.np(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).tr = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.jr() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.u2(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.u2.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion_0() {
    Companion_instance_1 = this;
    this.ur_1 = longArray(0);
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    Companion_getInstance_0();
    var elementsInLastSlot = elementsCount & (64 - 1 | 0);
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).w9(elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    Companion_getInstance_0();
    var offsetInSlot = index & (64 - 1 | 0);
    $this.yr_1[slot] = $this.yr_1[slot].aa((new Long(1, 0)).w9(offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.yr_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = slot + 1 | 0;
        Companion_getInstance_0();
        var slotOffset = imul(tmp, 64);
        var slotMarks = $this.yr_1[slot];
        while (!slotMarks.equals(new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(slotMarks.v9());
          slotMarks = slotMarks.aa((new Long(1, 0)).w9(indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.wr_1($this.vr_1, index)) {
            $this.yr_1[slot] = slotMarks;
            return index;
          }
        }
        $this.yr_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_7();
    this.vr_1 = descriptor;
    this.wr_1 = readIfAbsent;
    var elementsCount = this.vr_1.zj();
    Companion_getInstance_0();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      Companion_getInstance_0();
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).w9(elementsCount);
      }
      tmp.xr_1 = tmp_0;
      this.yr_1 = Companion_getInstance_7().ur_1;
    } else {
      this.xr_1 = new Long(0, 0);
      this.yr_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).zr = function (index) {
    Companion_getInstance_0();
    if (index < 64) {
      this.xr_1 = this.xr_1.aa((new Long(1, 0)).w9(index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).as = function () {
    var elementsCount = this.vr_1.zj();
    while (!this.xr_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.xr_1.v9());
      this.xr_1 = this.xr_1.aa((new Long(1, 0)).w9(index));
      if (this.wr_1(this.vr_1, index)) {
        return index;
      }
    }
    Companion_getInstance_0();
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createSimpleEnumSerializer(serialName, values) {
    return new EnumSerializer(serialName, values);
  }
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.bs_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.bs_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
      d.qs(element.h8_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.cs_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer(serialName, values) {
    this.bs_1 = values;
    this.cs_1 = null;
    var tmp = this;
    tmp.ds_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).ii = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ds_1;
    descriptor$factory_1();
    return this_0.f2();
  };
  protoOf(EnumSerializer).rs = function (encoder, value) {
    var index = indexOf(this.bs_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0('' + value + ' is not a valid enum ' + this.ii().jj() + ', ' + ('must be one of ' + contentToString(this.bs_1)));
    }
    encoder.zm(this.ii(), index);
  };
  protoOf(EnumSerializer).ji = function (encoder, value) {
    return this.rs(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).ki = function (decoder) {
    var index = decoder.ql(this.ii());
    if (!(0 <= index ? index <= (this.bs_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.ii().jj() + ' enum values, ' + ('values size is ' + this.bs_1.length));
    }
    return this.bs_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.ii().jj() + '>';
  };
  function _get_elementDescriptors__y23q9p($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.ft_1;
    elementDescriptors$factory();
    return this_0.f2();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.fk(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.et_1 = ENUM_getInstance();
    var tmp = this;
    tmp.ft_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).bk = function () {
    return this.et_1;
  };
  protoOf(EnumDescriptor).dk = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.bk() === ENUM_getInstance()))
      return false;
    if (!(this.jj() === other.jj()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString(get_elementNames(this), ', ', this.jj() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.jj());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = get_elementNames(this).u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function descriptor$factory_1() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ii();
    }, null);
  }
  function elementDescriptors$factory() {
    return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
      return _get_elementDescriptors__y23q9p(receiver);
    }, null);
  }
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.ut_1 = true;
  }
  protoOf(InlineClassDescriptor).ak = function () {
    return this.ut_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.jj() === other.jj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.ut_1 ? contentEquals(this.gt(), other.gt()) : false)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zj() === other.zj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zj();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.dk(index).jj() === other.dk(index).jj())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.dk(index).bk(), other.dk(index).bk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.vt_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.vt_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).ii = function () {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).ji = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).ki = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.yt_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).jm = function () {
    return this.yt_1;
  };
  protoOf(NoOpEncoder).om = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).pm = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).qm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).rm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).sm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).tm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).um = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).vm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).wm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).xm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).ym = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).zm = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.zt_1 = OBJECT_getInstance();
    this.au_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).bk = function () {
    return this.zt_1;
  };
  protoOf(NothingSerialDescriptor).jj = function () {
    return this.au_1;
  };
  protoOf(NothingSerialDescriptor).zj = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).fk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).ek = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).gk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).dk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).ck = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.au_1) + imul(31, this.zt_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.bu_1 = serializer;
    this.cu_1 = new SerialDescriptorForNullable(this.bu_1.ii());
  }
  protoOf(NullableSerializer).ii = function () {
    return this.cu_1;
  };
  protoOf(NullableSerializer).du = function (encoder, value) {
    if (!(value == null)) {
      encoder.pn();
      encoder.mn(this.bu_1, value);
    } else {
      encoder.pm();
    }
  };
  protoOf(NullableSerializer).ji = function (encoder, value) {
    return this.du(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).ki = function (decoder) {
    return decoder.fl() ? decoder.tl(this.bu_1) : decoder.gl();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.bu_1, other.bu_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.bu_1);
  };
  function SerialDescriptorForNullable(original) {
    this.hk_1 = original;
    this.ik_1 = this.hk_1.jj() + '?';
    this.jk_1 = cachedSerialNames(this.hk_1);
  }
  protoOf(SerialDescriptorForNullable).yj = function () {
    return this.hk_1.yj();
  };
  protoOf(SerialDescriptorForNullable).zj = function () {
    return this.hk_1.zj();
  };
  protoOf(SerialDescriptorForNullable).ak = function () {
    return this.hk_1.ak();
  };
  protoOf(SerialDescriptorForNullable).bk = function () {
    return this.hk_1.bk();
  };
  protoOf(SerialDescriptorForNullable).ck = function (index) {
    return this.hk_1.ck(index);
  };
  protoOf(SerialDescriptorForNullable).dk = function (index) {
    return this.hk_1.dk(index);
  };
  protoOf(SerialDescriptorForNullable).ek = function (name) {
    return this.hk_1.ek(name);
  };
  protoOf(SerialDescriptorForNullable).fk = function (index) {
    return this.hk_1.fk(index);
  };
  protoOf(SerialDescriptorForNullable).gk = function (index) {
    return this.hk_1.gk(index);
  };
  protoOf(SerialDescriptorForNullable).jj = function () {
    return this.ik_1;
  };
  protoOf(SerialDescriptorForNullable).dl = function () {
    return this.jk_1;
  };
  protoOf(SerialDescriptorForNullable).uj = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.hk_1, other.hk_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return '' + this.hk_1 + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.hk_1), 31);
  };
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.qi_1 = this$0.fu_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.eu_1 = objectInstance;
    this.fu_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.gu_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).ii = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.gu_1;
    descriptor$factory_2();
    return this_0.f2();
  };
  protoOf(ObjectSerializer).yi = function (encoder, value) {
    encoder.ul(this.ii()).vl(this.ii());
  };
  protoOf(ObjectSerializer).ji = function (encoder, value) {
    return this.yi(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).ki = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ii();
    var composite = decoder.ul(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.km()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.lm(this.ii());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    var result = tmp$ret$0;
    composite.vl(descriptor);
    return this.eu_1;
  };
  function descriptor$factory_2() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ii();
    }, null);
  }
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.dl();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.zj());
    var inductionVariable = 0;
    var last = _this__u8e3s4.zj();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.fk(i);
        result.r(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.n6();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        throw IllegalArgumentException_init_$Create$('Captured type parameter ' + t + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + t + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + t + '.'));
      } else {
        throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + t);
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function typeOrThrow(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      var value = _this__u8e3s4.if_1;
      // Inline function 'kotlin.contracts.contract' call
      if (value == null) {
        // Inline function 'kotlinx.serialization.internal.typeOrThrow.<anonymous>' call
        var message = 'Star projections in type arguments are not allowed, but had ' + _this__u8e3s4.if_1;
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$1 = value;
        break $l$block;
      }
    }
    return tmp$ret$1;
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.z5();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(_this__u8e3s4 == null ? true : _this__u8e3s4.b1())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.fk(i);
          missingFields.r(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.jj());
  }
  function _get_childSerializers__7vnyfa($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.ns_1;
    childSerializers$factory();
    return this_0.f2();
  }
  function _get__hashCode__tgwhef_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.ps_1;
    _hashCode$factory_0();
    return this_0.f2();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.is_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.is_1[i];
        indices.c2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.fs_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wt();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.fs_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xt();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.ii();
          destination.r(tmp$ret$0);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.gt());
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.fk(i) + ': ' + this$0.dk(i).jj();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.es_1 = serialName;
    this.fs_1 = generatedSerializer;
    this.gs_1 = elementsCount;
    this.hs_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.gs_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.is_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.gs_1;
    tmp_3.js_1 = fillArrayVal(Array(size), null);
    this.ks_1 = null;
    this.ls_1 = booleanArray(this.gs_1);
    this.ms_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.ns_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.os_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.ps_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).jj = function () {
    return this.es_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).zj = function () {
    return this.gs_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).bk = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).yj = function () {
    var tmp0_elvis_lhs = this.ks_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).dl = function () {
    return this.ms_1.z1();
  };
  protoOf(PluginGeneratedSerialDescriptor).gt = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.os_1;
    typeParameterDescriptors$factory();
    return this_0.f2();
  };
  protoOf(PluginGeneratedSerialDescriptor).ht = function (name, isOptional) {
    this.hs_1 = this.hs_1 + 1 | 0;
    this.is_1[this.hs_1] = name;
    this.ls_1[this.hs_1] = isOptional;
    this.js_1[this.hs_1] = null;
    if (this.hs_1 === (this.gs_1 - 1 | 0)) {
      this.ms_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).qs = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.ht(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.ht.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).dk = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).ii();
  };
  protoOf(PluginGeneratedSerialDescriptor).gk = function (index) {
    return getChecked_0(this.ls_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).ck = function (index) {
    var tmp0_elvis_lhs = getChecked(this.js_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).fk = function (index) {
    return getChecked(this.is_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).ek = function (name) {
    var tmp0_elvis_lhs = this.ms_1.m2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.jj() === other.jj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.gt(), other.gt())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zj() === other.zj())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zj();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.dk(index).jj() === other.dk(index).jj())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.dk(index).bk(), other.dk(index).bk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.gs_1);
    var tmp_0 = this.jj() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.jj());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = elementDescriptors.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver = element.jj();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var tmp0_iterator_0 = elementDescriptors.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver_0 = element_0.bk();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers__7vnyfa(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver.gt();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef_0(receiver);
    }, null);
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_1()));
  }
  protoOf(CharArraySerializer_0).ku = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.ku((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).lu = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.lu((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).pr = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).mu = function (decoder, index, builder, checkIndex) {
    builder.pu(decoder.dm(this.hr_1, index));
  };
  protoOf(CharArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.mu(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.mu(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).qu = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.in(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).rr = function (encoder, content, size) {
    return this.qu(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).tu = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.tu((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).uu = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.uu((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).pr = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).vu = function (decoder, index, builder, checkIndex) {
    builder.yu(decoder.cm(this.hr_1, index));
  };
  protoOf(DoubleArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.vu(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.vu(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).zu = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.hn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).rr = function (encoder, content, size) {
    return this.zu(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).cv = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.cv((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).dv = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.dv((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).pr = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).ev = function (decoder, index, builder, checkIndex) {
    builder.hv(decoder.bm(this.hr_1, index));
  };
  protoOf(FloatArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.ev(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.ev(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).iv = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.gn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).rr = function (encoder, content, size) {
    return this.iv(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_0()));
  }
  protoOf(LongArraySerializer_0).lv = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.lv((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).mv = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.mv((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).pr = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).nv = function (decoder, index, builder, checkIndex) {
    builder.qv(decoder.am(this.hr_1, index));
  };
  protoOf(LongArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.nv(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.nv(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).rv = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.fn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).rr = function (encoder, content, size) {
    return this.rv(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_2()));
  }
  protoOf(ULongArraySerializer_0).uv = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.uv(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.vh_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).vv = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.vv(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.vh_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).wv = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).pr = function () {
    return new ULongArray(this.wv());
  };
  protoOf(ULongArraySerializer_0).xv = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.fm(this.hr_1, index).ll();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.aw(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.xv(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.xv(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).bw = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.kn(this.hr_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.um(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).rr = function (encoder, content, size) {
    return this.bw(encoder, content instanceof ULongArray ? content.vh_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).ew = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.ew((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).fw = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.fw((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).pr = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).gw = function (decoder, index, builder, checkIndex) {
    builder.jw(decoder.zl(this.hr_1, index));
  };
  protoOf(IntArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.gw(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.gw(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).kw = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.en(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).rr = function (encoder, content, size) {
    return this.kw(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_3()));
  }
  protoOf(UIntArraySerializer_0).nw = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.nw(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.kh_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).ow = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.ow(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.kh_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).pw = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).pr = function () {
    return new UIntArray(this.pw());
  };
  protoOf(UIntArraySerializer_0).qw = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.fm(this.hr_1, index).kl();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.tw(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.qw(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.qw(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).uw = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.kn(this.hr_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.tm(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).rr = function (encoder, content, size) {
    return this.uw(encoder, content instanceof UIntArray ? content.kh_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).xw = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.xw((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).yw = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.yw((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).pr = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).zw = function (decoder, index, builder, checkIndex) {
    builder.cx(decoder.yl(this.hr_1, index));
  };
  protoOf(ShortArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.zw(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.zw(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).dx = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.dn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).rr = function (encoder, content, size) {
    return this.dx(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance_4()));
  }
  protoOf(UShortArraySerializer_0).gx = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.gx(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.gi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).hx = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.hx(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.gi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).ix = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).pr = function () {
    return new UShortArray(this.ix());
  };
  protoOf(UShortArraySerializer_0).jx = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.fm(this.hr_1, index).jl();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.mx(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.jx(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.jx(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).nx = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.kn(this.hr_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.sm(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).rr = function (encoder, content, size) {
    return this.nx(encoder, content instanceof UShortArray ? content.gi_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).qx = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.qx((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).rx = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.rx((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).pr = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).sx = function (decoder, index, builder, checkIndex) {
    builder.vx(decoder.xl(this.hr_1, index));
  };
  protoOf(ByteArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.sx(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.sx(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).wx = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.cn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).rr = function (encoder, content, size) {
    return this.wx(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(Companion_getInstance_5()));
  }
  protoOf(UByteArraySerializer_0).zx = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.zx(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.zg_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).ay = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.ay(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.zg_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).by = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).pr = function () {
    return new UByteArray(this.by());
  };
  protoOf(UByteArraySerializer_0).cy = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.fm(this.hr_1, index).il();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.fy(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.cy(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.cy(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).gy = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.kn(this.hr_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.rm(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).rr = function (encoder, content, size) {
    return this.gy(encoder, content instanceof UByteArray ? content.zg_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_14(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).jy = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).fq = function (_this__u8e3s4) {
    return this.jy((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).ky = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).ap = function (_this__u8e3s4) {
    return this.ky((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).pr = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).ly = function (decoder, index, builder, checkIndex) {
    builder.oy(decoder.wl(this.hr_1, index));
  };
  protoOf(BooleanArraySerializer_0).lp = function (decoder, index, builder, checkIndex) {
    return this.ly(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).qr = function (decoder, index, builder, checkIndex) {
    return this.ly(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).py = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.bn(this.hr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).rr = function (encoder, content, size) {
    return this.py(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.nu_1 = bufferWithData;
    this.ou_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(CharArrayBuilder).jr = function () {
    return this.ou_1;
  };
  protoOf(CharArrayBuilder).u2 = function (requiredCapacity) {
    if (this.nu_1.length < requiredCapacity)
      this.nu_1 = copyOf(this.nu_1, coerceAtLeast(requiredCapacity, imul(this.nu_1.length, 2)));
  };
  protoOf(CharArrayBuilder).pu = function (c) {
    this.tr();
    var tmp = this.nu_1;
    var tmp1 = this.ou_1;
    this.ou_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(CharArrayBuilder).lr = function () {
    return copyOf(this.nu_1, this.ou_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.wu_1 = bufferWithData;
    this.xu_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(DoubleArrayBuilder).jr = function () {
    return this.xu_1;
  };
  protoOf(DoubleArrayBuilder).u2 = function (requiredCapacity) {
    if (this.wu_1.length < requiredCapacity)
      this.wu_1 = copyOf_0(this.wu_1, coerceAtLeast(requiredCapacity, imul(this.wu_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).yu = function (c) {
    this.tr();
    var tmp = this.wu_1;
    var tmp1 = this.xu_1;
    this.xu_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(DoubleArrayBuilder).lr = function () {
    return copyOf_0(this.wu_1, this.xu_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.fv_1 = bufferWithData;
    this.gv_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(FloatArrayBuilder).jr = function () {
    return this.gv_1;
  };
  protoOf(FloatArrayBuilder).u2 = function (requiredCapacity) {
    if (this.fv_1.length < requiredCapacity)
      this.fv_1 = copyOf_1(this.fv_1, coerceAtLeast(requiredCapacity, imul(this.fv_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).hv = function (c) {
    this.tr();
    var tmp = this.fv_1;
    var tmp1 = this.gv_1;
    this.gv_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(FloatArrayBuilder).lr = function () {
    return copyOf_1(this.fv_1, this.gv_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.ov_1 = bufferWithData;
    this.pv_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(LongArrayBuilder).jr = function () {
    return this.pv_1;
  };
  protoOf(LongArrayBuilder).u2 = function (requiredCapacity) {
    if (this.ov_1.length < requiredCapacity)
      this.ov_1 = copyOf_2(this.ov_1, coerceAtLeast(requiredCapacity, imul(this.ov_1.length, 2)));
  };
  protoOf(LongArrayBuilder).qv = function (c) {
    this.tr();
    var tmp = this.ov_1;
    var tmp1 = this.pv_1;
    this.pv_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(LongArrayBuilder).lr = function () {
    return copyOf_2(this.ov_1, this.pv_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.yv_1 = bufferWithData;
    this.zv_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.u2(10);
  }
  protoOf(ULongArrayBuilder).jr = function () {
    return this.zv_1;
  };
  protoOf(ULongArrayBuilder).u2 = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.yv_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.yv_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.yv_1), 2));
      tmp.yv_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).aw = function (c) {
    this.tr();
    var tmp = this.yv_1;
    var tmp1 = this.zv_1;
    this.zv_1 = tmp1 + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
  };
  protoOf(ULongArrayBuilder).qy = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.yv_1;
    var newSize = this.zv_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
  };
  protoOf(ULongArrayBuilder).lr = function () {
    return new ULongArray(this.qy());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.hw_1 = bufferWithData;
    this.iw_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(IntArrayBuilder).jr = function () {
    return this.iw_1;
  };
  protoOf(IntArrayBuilder).u2 = function (requiredCapacity) {
    if (this.hw_1.length < requiredCapacity)
      this.hw_1 = copyOf_3(this.hw_1, coerceAtLeast(requiredCapacity, imul(this.hw_1.length, 2)));
  };
  protoOf(IntArrayBuilder).jw = function (c) {
    this.tr();
    var tmp = this.hw_1;
    var tmp1 = this.iw_1;
    this.iw_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(IntArrayBuilder).lr = function () {
    return copyOf_3(this.hw_1, this.iw_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.rw_1 = bufferWithData;
    this.sw_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.u2(10);
  }
  protoOf(UIntArrayBuilder).jr = function () {
    return this.sw_1;
  };
  protoOf(UIntArrayBuilder).u2 = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.rw_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.rw_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.rw_1), 2));
      tmp.rw_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).tw = function (c) {
    this.tr();
    var tmp = this.rw_1;
    var tmp1 = this.sw_1;
    this.sw_1 = tmp1 + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
  };
  protoOf(UIntArrayBuilder).ry = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.rw_1;
    var newSize = this.sw_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
  };
  protoOf(UIntArrayBuilder).lr = function () {
    return new UIntArray(this.ry());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.ax_1 = bufferWithData;
    this.bx_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(ShortArrayBuilder).jr = function () {
    return this.bx_1;
  };
  protoOf(ShortArrayBuilder).u2 = function (requiredCapacity) {
    if (this.ax_1.length < requiredCapacity)
      this.ax_1 = copyOf_4(this.ax_1, coerceAtLeast(requiredCapacity, imul(this.ax_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).cx = function (c) {
    this.tr();
    var tmp = this.ax_1;
    var tmp1 = this.bx_1;
    this.bx_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ShortArrayBuilder).lr = function () {
    return copyOf_4(this.ax_1, this.bx_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.kx_1 = bufferWithData;
    this.lx_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.u2(10);
  }
  protoOf(UShortArrayBuilder).jr = function () {
    return this.lx_1;
  };
  protoOf(UShortArrayBuilder).u2 = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.kx_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.kx_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.kx_1), 2));
      tmp.kx_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).mx = function (c) {
    this.tr();
    var tmp = this.kx_1;
    var tmp1 = this.lx_1;
    this.lx_1 = tmp1 + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
  };
  protoOf(UShortArrayBuilder).sy = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.kx_1;
    var newSize = this.lx_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
  };
  protoOf(UShortArrayBuilder).lr = function () {
    return new UShortArray(this.sy());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.tx_1 = bufferWithData;
    this.ux_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(ByteArrayBuilder).jr = function () {
    return this.ux_1;
  };
  protoOf(ByteArrayBuilder).u2 = function (requiredCapacity) {
    if (this.tx_1.length < requiredCapacity)
      this.tx_1 = copyOf_5(this.tx_1, coerceAtLeast(requiredCapacity, imul(this.tx_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).vx = function (c) {
    this.tr();
    var tmp = this.tx_1;
    var tmp1 = this.ux_1;
    this.ux_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ByteArrayBuilder).lr = function () {
    return copyOf_5(this.tx_1, this.ux_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.dy_1 = bufferWithData;
    this.ey_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.u2(10);
  }
  protoOf(UByteArrayBuilder).jr = function () {
    return this.ey_1;
  };
  protoOf(UByteArrayBuilder).u2 = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.dy_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.dy_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.dy_1), 2));
      tmp.dy_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).fy = function (c) {
    this.tr();
    var tmp = this.dy_1;
    var tmp1 = this.ey_1;
    this.ey_1 = tmp1 + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
  };
  protoOf(UByteArrayBuilder).ty = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.dy_1;
    var newSize = this.ey_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
  };
  protoOf(UByteArrayBuilder).lr = function () {
    return new UByteArray(this.ty());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.my_1 = bufferWithData;
    this.ny_1 = bufferWithData.length;
    this.u2(10);
  }
  protoOf(BooleanArrayBuilder).jr = function () {
    return this.ny_1;
  };
  protoOf(BooleanArrayBuilder).u2 = function (requiredCapacity) {
    if (this.my_1.length < requiredCapacity)
      this.my_1 = copyOf_6(this.my_1, coerceAtLeast(requiredCapacity, imul(this.my_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).oy = function (c) {
    this.tr();
    var tmp = this.my_1;
    var tmp1 = this.ny_1;
    this.ny_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(BooleanArrayBuilder).lr = function () {
    return copyOf_6(this.my_1, this.ny_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().m2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.uy_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).ii = function () {
    return this.uy_1;
  };
  protoOf(StringSerializer).vy = function (encoder, value) {
    return encoder.ym(value);
  };
  protoOf(StringSerializer).ji = function (encoder, value) {
    return this.vy(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).ki = function (decoder) {
    return decoder.pl();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.wy_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).ii = function () {
    return this.wy_1;
  };
  protoOf(CharSerializer).xy = function (encoder, value) {
    return encoder.xm(value);
  };
  protoOf(CharSerializer).ji = function (encoder, value) {
    return this.xy(encoder, value instanceof Char ? value.v8_1 : THROW_CCE());
  };
  protoOf(CharSerializer).yy = function (decoder) {
    return decoder.ol();
  };
  protoOf(CharSerializer).ki = function (decoder) {
    return new Char(this.yy(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.zy_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).ii = function () {
    return this.zy_1;
  };
  protoOf(DoubleSerializer).az = function (encoder, value) {
    return encoder.wm(value);
  };
  protoOf(DoubleSerializer).ji = function (encoder, value) {
    return this.az(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).ki = function (decoder) {
    return decoder.nl();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.bz_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).ii = function () {
    return this.bz_1;
  };
  protoOf(FloatSerializer).cz = function (encoder, value) {
    return encoder.vm(value);
  };
  protoOf(FloatSerializer).ji = function (encoder, value) {
    return this.cz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).ki = function (decoder) {
    return decoder.ml();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.dz_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).ii = function () {
    return this.dz_1;
  };
  protoOf(LongSerializer).ez = function (encoder, value) {
    return encoder.um(value);
  };
  protoOf(LongSerializer).ji = function (encoder, value) {
    return this.ez(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).ki = function (decoder) {
    return decoder.ll();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.fz_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).ii = function () {
    return this.fz_1;
  };
  protoOf(IntSerializer).gz = function (encoder, value) {
    return encoder.tm(value);
  };
  protoOf(IntSerializer).ji = function (encoder, value) {
    return this.gz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).ki = function (decoder) {
    return decoder.kl();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.hz_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).ii = function () {
    return this.hz_1;
  };
  protoOf(ShortSerializer).iz = function (encoder, value) {
    return encoder.sm(value);
  };
  protoOf(ShortSerializer).ji = function (encoder, value) {
    return this.iz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).ki = function (decoder) {
    return decoder.jl();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.jz_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).ii = function () {
    return this.jz_1;
  };
  protoOf(ByteSerializer).kz = function (encoder, value) {
    return encoder.rm(value);
  };
  protoOf(ByteSerializer).ji = function (encoder, value) {
    return this.kz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).ki = function (decoder) {
    return decoder.il();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.lz_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).ii = function () {
    return this.lz_1;
  };
  protoOf(BooleanSerializer).mz = function (encoder, value) {
    return encoder.qm(value);
  };
  protoOf(BooleanSerializer).ji = function (encoder, value) {
    return this.mz(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).ki = function (decoder) {
    return decoder.hl();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.nz_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).ii = function () {
    return this.nz_1.ii();
  };
  protoOf(UnitSerializer).oz = function (decoder) {
    this.nz_1.ki(decoder);
  };
  protoOf(UnitSerializer).ki = function (decoder) {
    this.oz(decoder);
    return Unit_instance;
  };
  protoOf(UnitSerializer).pz = function (encoder, value) {
    this.nz_1.yi(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).ji = function (encoder, value) {
    return this.pz(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.qz_1 = serialName;
    this.rz_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).jj = function () {
    return this.qz_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).bk = function () {
    return this.rz_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).zj = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).fk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).ek = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).gk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).dk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).ck = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.qz_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.qz_1 === other.qz_1 ? equals(this.rz_1, other.rz_1) : false)
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.qz_1) + imul(31, this.rz_1.hashCode()) | 0;
  };
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var keys = get_BUILTIN_SERIALIZERS().z1();
    var tmp0_iterator = keys.u();
    while (tmp0_iterator.v()) {
      var primitive = tmp0_iterator.w();
      var simpleName = capitalize(ensureNotNull(primitive.z5()));
      var qualifiedName = 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) ? true : equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function capitalize(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
      var it = charSequenceGet(_this__u8e3s4, 0);
      var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_0(it);
      var tmp_0 = toString(tmp$ret$1);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp_0 + _this__u8e3s4.substring(1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().e7(), serializer_2(StringCompanionObject_instance)), to(getKClass(Char), serializer_3(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().h7(), CharArraySerializer()), to(PrimitiveClasses_getInstance().c7(), serializer_4(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().n7(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().b7(), serializer_5(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().m7(), FloatArraySerializer()), to(getKClass(Long), serializer_6(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().l7(), LongArraySerializer()), to(getKClass(ULong), serializer_7(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().a7(), serializer_8(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().k7(), IntArraySerializer()), to(getKClass(UInt), serializer_9(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().z6(), serializer_10(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().j7(), ShortArraySerializer()), to(getKClass(UShort), serializer_11(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().y6(), serializer_12(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().i7(), ByteArraySerializer()), to(getKClass(UByte), serializer_13(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().x6(), serializer_14(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().g7(), BooleanArraySerializer()), to(getKClass(Unit), serializer_15(Unit_instance)), to(PrimitiveClasses_getInstance().w6(), NothingSerializer()), to(getKClass(Duration), serializer_16(Companion_getInstance()))]);
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).uz = function (_this__u8e3s4, index) {
    return this.wz(this.vz(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).wz = function (nestedName) {
    var tmp0_elvis_lhs = this.zz();
    return this.a10(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).vz = function (descriptor, index) {
    return descriptor.fk(index);
  };
  protoOf(NamedValueDecoder).a10 = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.o10(tag);
    var r = block();
    if (!$this.yz_1) {
      $this.p10();
    }
    $this.yz_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.sl($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
      var this_0 = this$0;
      var isNullabilitySupported = $deserializer.ii().uj();
      var tmp;
      if (isNullabilitySupported ? true : this_0.fl()) {
        // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeNullableSerializableElement.<anonymous>.<anonymous>' call
        tmp = this$0.sl($deserializer, $previousValue);
      } else {
        tmp = this_0.gl();
      }
      return tmp;
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.xz_1 = ArrayList_init_$Create$_0();
    this.yz_1 = false;
  }
  protoOf(TaggedDecoder).jm = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).b10 = function (tag) {
    throw SerializationException_init_$Create$_0('' + getKClassFromExpression(this) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).c10 = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).d10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).e10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).f10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).g10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).h10 = function (tag) {
    var tmp = this.b10(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).i10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).j10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).k10 = function (tag) {
    var tmp = this.b10(tag);
    return tmp instanceof Char ? tmp.v8_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).l10 = function (tag) {
    var tmp = this.b10(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).m10 = function (tag, enumDescriptor) {
    var tmp = this.b10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).n10 = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.o10(tag);
    return this;
  };
  protoOf(TaggedDecoder).sl = function (deserializer, previousValue) {
    return this.tl(deserializer);
  };
  protoOf(TaggedDecoder).rl = function (descriptor) {
    return this.n10(this.p10(), descriptor);
  };
  protoOf(TaggedDecoder).fl = function () {
    var tmp0_elvis_lhs = this.zz();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.c10(currentTag);
  };
  protoOf(TaggedDecoder).gl = function () {
    return null;
  };
  protoOf(TaggedDecoder).hl = function () {
    return this.d10(this.p10());
  };
  protoOf(TaggedDecoder).il = function () {
    return this.e10(this.p10());
  };
  protoOf(TaggedDecoder).jl = function () {
    return this.f10(this.p10());
  };
  protoOf(TaggedDecoder).kl = function () {
    return this.g10(this.p10());
  };
  protoOf(TaggedDecoder).ll = function () {
    return this.h10(this.p10());
  };
  protoOf(TaggedDecoder).ml = function () {
    return this.i10(this.p10());
  };
  protoOf(TaggedDecoder).nl = function () {
    return this.j10(this.p10());
  };
  protoOf(TaggedDecoder).ol = function () {
    return this.k10(this.p10());
  };
  protoOf(TaggedDecoder).pl = function () {
    return this.l10(this.p10());
  };
  protoOf(TaggedDecoder).ql = function (enumDescriptor) {
    return this.m10(this.p10(), enumDescriptor);
  };
  protoOf(TaggedDecoder).ul = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).vl = function (descriptor) {
  };
  protoOf(TaggedDecoder).wl = function (descriptor, index) {
    return this.d10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).xl = function (descriptor, index) {
    return this.e10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).yl = function (descriptor, index) {
    return this.f10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).zl = function (descriptor, index) {
    return this.g10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).am = function (descriptor, index) {
    return this.h10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).bm = function (descriptor, index) {
    return this.i10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).cm = function (descriptor, index) {
    return this.j10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).dm = function (descriptor, index) {
    return this.k10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).em = function (descriptor, index) {
    return this.l10(this.uz(descriptor, index));
  };
  protoOf(TaggedDecoder).fm = function (descriptor, index) {
    return this.n10(this.uz(descriptor, index), descriptor.dk(index));
  };
  protoOf(TaggedDecoder).gm = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.uz(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).im = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.uz(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).zz = function () {
    return lastOrNull(this.xz_1);
  };
  protoOf(TaggedDecoder).o10 = function (name) {
    this.xz_1.r(name);
  };
  protoOf(TaggedDecoder).p10 = function () {
    var r = this.xz_1.h1(get_lastIndex_0(this.xz_1));
    this.yz_1 = true;
    return r;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.q10_1 = key;
    this.r10_1 = value;
  }
  protoOf(MapEntry).e2 = function () {
    return this.q10_1;
  };
  protoOf(MapEntry).f2 = function () {
    return this.r10_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + this.q10_1 + ', value=' + this.r10_1 + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.q10_1 == null ? 0 : hashCode(this.q10_1);
    result = imul(result, 31) + (this.r10_1 == null ? 0 : hashCode(this.r10_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.q10_1, tmp0_other_with_cast.q10_1))
      return false;
    if (!equals(this.r10_1, tmp0_other_with_cast.r10_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.wi('key', $keySerializer.ii());
      $this$buildSerialDescriptor.wi('value', $valueSerializer.ii());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.u10_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).ii = function () {
    return this.u10_1;
  };
  protoOf(MapEntrySerializer_0).v10 = function (_this__u8e3s4) {
    return _this__u8e3s4.e2();
  };
  protoOf(MapEntrySerializer_0).w10 = function (_this__u8e3s4) {
    return this.v10((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).x10 = function (_this__u8e3s4) {
    return _this__u8e3s4.f2();
  };
  protoOf(MapEntrySerializer_0).y10 = function (_this__u8e3s4) {
    return this.x10((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).z10 = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.wi('first', $keySerializer.ii());
      $this$buildClassSerialDescriptor.wi('second', $valueSerializer.ii());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.f11_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).ii = function () {
    return this.f11_1;
  };
  protoOf(PairSerializer_0).g11 = function (_this__u8e3s4) {
    return _this__u8e3s4.kd_1;
  };
  protoOf(PairSerializer_0).w10 = function (_this__u8e3s4) {
    return this.g11(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).h11 = function (_this__u8e3s4) {
    return _this__u8e3s4.ld_1;
  };
  protoOf(PairSerializer_0).y10 = function (_this__u8e3s4) {
    return this.h11(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).z10 = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.hm($this.l11_1, 0, $this.i11_1);
    var b = composite.hm($this.l11_1, 1, $this.j11_1);
    var c = composite.hm($this.l11_1, 2, $this.k11_1);
    composite.vl($this.l11_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.lm($this.l11_1);
      if (index === -1) {
        break mainLoop;
      } else {
        if (index === 0) {
          a = composite.hm($this.l11_1, 0, $this.i11_1);
        } else {
          if (index === 1) {
            b = composite.hm($this.l11_1, 1, $this.j11_1);
          } else {
            if (index === 2) {
              c = composite.hm($this.l11_1, 2, $this.k11_1);
            } else {
              throw SerializationException_init_$Create$_0('Unexpected index ' + index);
            }
          }
        }
      }
    }
    composite.vl($this.l11_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.wi('first', this$0.i11_1.ii());
      $this$buildClassSerialDescriptor.wi('second', this$0.j11_1.ii());
      $this$buildClassSerialDescriptor.wi('third', this$0.k11_1.ii());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.i11_1 = aSerializer;
    this.j11_1 = bSerializer;
    this.k11_1 = cSerializer;
    var tmp = this;
    tmp.l11_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).ii = function () {
    return this.l11_1;
  };
  protoOf(TripleSerializer_0).m11 = function (encoder, value) {
    var structuredEncoder = encoder.ul(this.l11_1);
    structuredEncoder.ln(this.l11_1, 0, this.i11_1, value.ng_1);
    structuredEncoder.ln(this.l11_1, 1, this.j11_1, value.og_1);
    structuredEncoder.ln(this.l11_1, 2, this.k11_1, value.pg_1);
    structuredEncoder.vl(this.l11_1);
  };
  protoOf(TripleSerializer_0).ji = function (encoder, value) {
    return this.m11(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).ki = function (decoder) {
    var composite = decoder.ul(this.l11_1);
    if (composite.km()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.a11_1 = keySerializer;
    this.b11_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).c11 = function (encoder, value) {
    var structuredEncoder = encoder.ul(this.ii());
    structuredEncoder.ln(this.ii(), 0, this.a11_1, this.w10(value));
    structuredEncoder.ln(this.ii(), 1, this.b11_1, this.y10(value));
    structuredEncoder.vl(this.ii());
  };
  protoOf(KeyValueSerializer).ji = function (encoder, value) {
    return this.c11(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).ki = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ii();
    var composite = decoder.ul(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.km()) {
        var key = composite.hm(this.ii(), 0, this.a11_1);
        var value = composite.hm(this.ii(), 1, this.b11_1);
        tmp$ret$0 = this.z10(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.lm(this.ii());
        if (idx === -1) {
          break mainLoop;
        } else {
          if (idx === 0) {
            key_0 = composite.hm(this.ii(), 0, this.a11_1);
          } else {
            if (idx === 1) {
              value_0 = composite.hm(this.ii(), 1, this.b11_1);
            } else {
              throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
            }
          }
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.z10(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.vl(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.n11_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_6(Companion_getInstance_0()));
  }
  protoOf(ULongSerializer).ii = function () {
    return this.n11_1;
  };
  protoOf(ULongSerializer).o11 = function (encoder, value) {
    var tmp = encoder.an(this.n11_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.um(tmp$ret$0);
  };
  protoOf(ULongSerializer).ji = function (encoder, value) {
    return this.o11(encoder, value instanceof ULong ? value.qh_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).p11 = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.rl(this.n11_1).ll();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).ki = function (decoder) {
    return new ULong(this.p11(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.q11_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_8(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).ii = function () {
    return this.q11_1;
  };
  protoOf(UIntSerializer).r11 = function (encoder, value) {
    var tmp = encoder.an(this.q11_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.tm(tmp$ret$0);
  };
  protoOf(UIntSerializer).ji = function (encoder, value) {
    return this.r11(encoder, value instanceof UInt ? value.fh_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).s11 = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.rl(this.q11_1).kl();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).ki = function (decoder) {
    return new UInt(this.s11(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.t11_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_10(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).ii = function () {
    return this.t11_1;
  };
  protoOf(UShortSerializer).u11 = function (encoder, value) {
    var tmp = encoder.an(this.t11_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.sm(tmp$ret$0);
  };
  protoOf(UShortSerializer).ji = function (encoder, value) {
    return this.u11(encoder, value instanceof UShort ? value.bi_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).v11 = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.rl(this.t11_1).jl();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).ki = function (decoder) {
    return new UShort(this.v11(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.w11_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_12(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).ii = function () {
    return this.w11_1;
  };
  protoOf(UByteSerializer).x11 = function (encoder, value) {
    var tmp = encoder.an(this.w11_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.rm(tmp$ret$0);
  };
  protoOf(UByteSerializer).ji = function (encoder, value) {
    return this.x11(encoder, value instanceof UByte ? value.ug_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).y11 = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.rl(this.w11_1).il();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).ki = function (decoder) {
    return new UByte(this.y11(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).rj = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.qj(kClass, typeArgumentsSerializers) : $super.qj.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    SerializersModule.call(this);
    this.a12_1 = class2ContextualFactory;
    this.b12_1 = polyBase2Serializers;
    this.c12_1 = polyBase2DefaultSerializerProvider;
    this.d12_1 = polyBase2NamedSerializers;
    this.e12_1 = polyBase2DefaultDeserializerProvider;
  }
  protoOf(SerialModuleImpl).vn = function (baseClass, value) {
    if (!baseClass.a6(value))
      return null;
    var tmp0_safe_receiver = this.b12_1.m2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.c12_1.m2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).un = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.d12_1.m2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, Map) ? tmp0_safe_receiver : THROW_CCE()).m2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.e12_1.m2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).qj = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.a12_1.m2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f12(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).z11 = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.a12_1.b2().u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.e2();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.f2();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.i12_1;
        collector.j12(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.h12(kclass, serial.g12_1);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this.b12_1.b2().u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.e2();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.f2();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = classMap.b2().u();
      while (tmp0_iterator_1.v()) {
        var element_1 = tmp0_iterator_1.w();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.e2();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.f2();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.k12(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = this.c12_1.b2().u();
    while (tmp0_iterator_2.v()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.e2();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.f2();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.l12(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this.e12_1.b2().u();
    while (tmp0_iterator_3.v()) {
      var element_3 = tmp0_iterator_3.w();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.e2();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.f2();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.m12(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless() {
  }
  function WithTypeArguments() {
  }
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.n12_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.n12_1.equals(tmp0_other_with_cast.n12_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.n12_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(serializer=' + this.n12_1 + ')';
  };
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().w6()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().d7());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.hu(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          if (get_isInterface(_this__u8e3s4)) {
            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
          } else {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function get_isInterface(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4));
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4));
    return _this__u8e3s4[index];
  }
  function createCache$1($factory) {
    this.o12_1 = $factory;
  }
  protoOf(createCache$1).sj = function (key) {
    return this.o12_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.p12_1 = $factory;
  }
  protoOf(createParametrizedCache$1).tj = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var value = this.p12_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).uj = get_isNullable;
  protoOf(SerialDescriptorImpl).ak = get_isInline;
  protoOf(AbstractDecoder).hm = decodeSerializableElement$default;
  protoOf(AbstractDecoder).tl = decodeSerializableValue;
  protoOf(AbstractDecoder).km = decodeSequentially;
  protoOf(AbstractDecoder).mm = decodeCollectionSize;
  protoOf(AbstractEncoder).pn = encodeNotNullMark;
  protoOf(AbstractEncoder).qn = beginCollection;
  protoOf(AbstractEncoder).mn = encodeSerializableValue;
  protoOf(AbstractEncoder).on = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).rn = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).uj = get_isNullable;
  protoOf(ListLikeDescriptor).ak = get_isInline;
  protoOf(ListLikeDescriptor).yj = get_annotations;
  protoOf(MapLikeDescriptor).uj = get_isNullable;
  protoOf(MapLikeDescriptor).ak = get_isInline;
  protoOf(MapLikeDescriptor).yj = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).uj = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).ak = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).xt = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).uj = get_isNullable;
  protoOf(NothingSerialDescriptor).ak = get_isInline;
  protoOf(NothingSerialDescriptor).yj = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).uj = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).ak = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).yj = get_annotations;
  protoOf(TaggedDecoder).hm = decodeSerializableElement$default;
  protoOf(TaggedDecoder).tl = decodeSerializableValue;
  protoOf(TaggedDecoder).km = decodeSequentially;
  protoOf(TaggedDecoder).mm = decodeCollectionSize;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = PolymorphicSerializer_init_$Create$;
  _.$_$.b = SealedClassSerializer_init_$Create$;
  _.$_$.c = SerializationException_init_$Init$_0;
  _.$_$.d = SerializationException_init_$Create$_0;
  _.$_$.e = UnknownFieldException_init_$Create$;
  _.$_$.f = SEALED_getInstance;
  _.$_$.g = STRING_getInstance;
  _.$_$.h = CONTEXTUAL_getInstance;
  _.$_$.i = ENUM_getInstance;
  _.$_$.j = CLASS_getInstance;
  _.$_$.k = LIST_getInstance;
  _.$_$.l = MAP_getInstance;
  _.$_$.m = OBJECT_getInstance;
  _.$_$.n = Companion_instance_0;
  _.$_$.o = DoubleSerializer_getInstance;
  _.$_$.p = IntSerializer_getInstance;
  _.$_$.q = LongSerializer_getInstance;
  _.$_$.r = StringSerializer_getInstance;
  _.$_$.s = ListSerializer;
  _.$_$.t = MapSerializer;
  _.$_$.u = SetSerializer;
  _.$_$.v = get_nullable;
  _.$_$.w = serializer_2;
  _.$_$.x = serializer_11;
  _.$_$.y = serializer_9;
  _.$_$.z = serializer_13;
  _.$_$.a1 = serializer_7;
  _.$_$.b1 = PolymorphicKind;
  _.$_$.c1 = PrimitiveKind;
  _.$_$.d1 = PrimitiveSerialDescriptor;
  _.$_$.e1 = get_annotations;
  _.$_$.f1 = get_isInline;
  _.$_$.g1 = get_isNullable;
  _.$_$.h1 = SerialDescriptor;
  _.$_$.i1 = ENUM;
  _.$_$.j1 = buildSerialDescriptor;
  _.$_$.k1 = getContextualDescriptor;
  _.$_$.l1 = AbstractDecoder;
  _.$_$.m1 = AbstractEncoder;
  _.$_$.n1 = CompositeDecoder;
  _.$_$.o1 = CompositeEncoder;
  _.$_$.p1 = Decoder;
  _.$_$.q1 = Encoder;
  _.$_$.r1 = AbstractPolymorphicSerializer;
  _.$_$.s1 = ArrayListSerializer;
  _.$_$.t1 = ElementMarker;
  _.$_$.u1 = typeParametersSerializers;
  _.$_$.v1 = GeneratedSerializer;
  _.$_$.w1 = InlinePrimitiveDescriptor;
  _.$_$.x1 = LinkedHashMapSerializer;
  _.$_$.y1 = NamedValueDecoder;
  _.$_$.z1 = PluginGeneratedSerialDescriptor;
  _.$_$.a2 = ReferenceArraySerializer;
  _.$_$.b2 = SerializerFactory;
  _.$_$.c2 = createSimpleEnumSerializer;
  _.$_$.d2 = jsonCachedSerialNames;
  _.$_$.e2 = throwMissingFieldException;
  _.$_$.f2 = EmptySerializersModule_0;
  _.$_$.g2 = contextual;
  _.$_$.h2 = SerializersModuleCollector;
  _.$_$.i2 = BinaryFormat;
  _.$_$.j2 = DeserializationStrategy;
  _.$_$.k2 = KSerializer;
  _.$_$.l2 = MissingFieldException;
  _.$_$.m2 = SealedClassSerializer;
  _.$_$.n2 = SerializationException;
  _.$_$.o2 = SerializationStrategy;
  _.$_$.p2 = StringFormat;
  _.$_$.q2 = findPolymorphicSerializer_0;
  _.$_$.r2 = findPolymorphicSerializer;
  _.$_$.s2 = serializerOrNull_0;
  _.$_$.t2 = serializer_0;
  _.$_$.u2 = serializer_1;
  _.$_$.v2 = serializer;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-core.js.map
